import React from 'react';


//Img
import SubPhotoSample1 from '../img/help/help_sub-photo_sample1.png';
import SubPhotoSample2 from '../img/help/help_sub-photo_sample2.png';
import SubPhotoSample3 from '../img/help/help_sub-photo_sample3.png';


class Comp extends React.Component {
  render() {
  	return (
    <div>
      <div style={{padding:5,fontSize:'0.9em',color:'#666'}}>
        サブ写真にはお顔が写っていないこんな写真も掲載できます。
      </div>
      <div
        style={{
          display:'flex',
          flexDirection:'row',
          alignItems:'center',
          justifyContent:'center',
          userSelect:'none',
        }}
      >
        <div style={{position:'relative'}}>
          <img
            src={SubPhotoSample1}
            style={{ maxWidth:'100px', width:'100%', height:'auto'}}
            alt=''
          />
          <div
            style={{position :'absolute', bottom:'0px', left:'0px', width:'100%', textAlign:'center', background:'rgba(0, 0, 0, 0.5)', color:'#FFF',fontSize:'0.8em'}}
          >
            景色
          </div>
        </div>
        <div style={{position:'relative'}}>
          <img
            src={SubPhotoSample2}
            style={{ maxWidth:'100px', width:'100%', height:'auto'}}
            alt=''
          />
          <div
            style={{position :'absolute', bottom:'0px', left:'0px', width:'100%', textAlign:'center', background:'rgba(0, 0, 0, 0.5)', color:'#FFF',fontSize:'0.8em'}}
          >
            ペット
          </div>
        </div>
        <div style={{position:'relative'}}>
          <img
            src={SubPhotoSample3}
            style={{ maxWidth:'100px', width:'100%', height:'auto'}}
            alt=''
          />
          <div
            style={{position :'absolute', bottom:'0px', left:'0px', width:'100%', textAlign:'center', background:'rgba(0, 0, 0, 0.5)', color:'#FFF',fontSize:'0.8em'}}
          >
            趣味
          </div>
        </div>

      </div>

    </div>
  	)
  }
}

export default Comp;
